import Immutable from 'immutable';

import { isObject } from '../../isObject';

import { ALL, FORMS } from '../../../constants/profiles';
import { EMPTY } from '../../../constants';

export function setAll(sections) {
  function reduceSections(result, selected, item) {
    switch (item) {
      case ALL: {
        return result;
      }

      default: {
        return result && selected;
      }
    }
  }

  return sections.set(ALL, sections.reduce(reduceSections, true));
}

export function getProfileSections({ channel, value = false }) {
  function reduceSections(sections, section) {
    if (typeof value === 'boolean') {
      return sections.set(section, value);
    }

    if (typeof value === 'function') {
      return sections.set(section, value(section));
    }

    if (Immutable.isImmutable(value)) {
      return sections.set(section, value.get(section) || false);
    }

    if (isObject(value)) {
      return sections.set(section, value[section] || false);
    }

    return sections.set(section, false);
  }

  return FORMS[channel].reduce(reduceSections, EMPTY.MAP);
}

export function updateProfileSections({ channel, section, sections, value }) {
  switch (section) {
    case ALL: {
      return setAll(getProfileSections({ channel, value }));
    }

    default: {
      return setAll(sections.set(section, value));
    }
  }
}
